import { render } from "./TBWTTNLCards.vue?vue&type=template&id=61882278&scoped=true"
import script from "./TBWTTNLCards.vue?vue&type=script&lang=js"
export * from "./TBWTTNLCards.vue?vue&type=script&lang=js"

import "./TBWTTNLCards.vue?vue&type=style&index=0&id=61882278&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61882278"]])

export default __exports__